import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Heart, Ear } from 'lucide-react';
import { team, coachAbrieBio as bio } from '../../data/mock';

const ICONS = [ShieldCheck, Heart, Ear];
const abrie = team.find((m) => m.lead);

export default function MeetCoachAbrie() {
  return (
    <section className="py-20 md:py-24 bg-splash-green text-splash-cream" data-testid="home-meet-abrie">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-4 lg:sticky lg:top-28">
          <div className="aspect-[4/5] max-w-sm rounded-[2rem] overflow-hidden border-4 border-splash-cream/10 shadow-2xl">
            <img src={abrie.image} alt="Coach Abrie Freeman, owner and lead instructor" loading="lazy" decoding="async" className="w-full h-full object-cover object-top" />
          </div>
          <div className="mt-5 text-base">
            <div className="font-bold text-white">{bio.signature}</div>
            <div className="text-splash-coral font-semibold">{bio.title}</div>
            <div className="text-splash-cream/70">{abrie.credentials}</div>
          </div>
        </div>
        <div className="lg:col-span-8 text-base md:text-lg leading-relaxed text-splash-cream/85">
          <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">Meet Coach Abrie</div>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white leading-tight">Fear isn&rsquo;t a requirement for learning to swim.</h2>
          <p className="mt-6">{bio.intro}</p>
          <p className="mt-4">{bio.philosophy}</p>
          <p className="mt-6 font-semibold text-white">{bio.takeawaysLead}</p>
          <ol className="mt-5 grid gap-4">
            {bio.takeaways.map((t, i) => {
              const Icon = ICONS[i];
              return (
                <li key={t.title} data-testid={`abrie-takeaway-${i}`} className="rounded-2xl bg-white/5 border border-white/10 p-5 flex gap-4">
                  <div className="shrink-0 w-10 h-10 rounded-full bg-splash-coral grid place-items-center"><Icon className="w-5 h-5 text-white" /></div>
                  <p><strong className="text-splash-coral">{t.title}</strong> {t.body}</p>
                </li>
              );
            })}
          </ol>
          <p data-testid="abrie-emotional" className="mt-8 border-l-4 border-splash-coral pl-5 font-semibold text-white">{bio.emotional}</p>
          <p className="mt-8">{bio.closing}</p>
          <Link to="/book?type=assessment" data-testid="abrie-book-assessment-btn" className="inline-flex items-center gap-2 mt-6 rounded-full bg-splash-coral hover:bg-splash-coralDark text-white px-7 py-3.5 font-semibold btn-transition">
            Book a Swim Assessment <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
